module.exports = __webpack_public_path__ + "img/gallery1.54c91ae.jpg";